//
// LinkBar.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../../lib";
import "../PromptSpecialization";
import "../PromptOrientation";
import "../../../dataDefinition/DataItem";

var LinkBar = createModule("BIRD::LinkBar", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::PromptSpecialization"], EventDispatcher, [
    ,
    {
        orientation: 4,
        valueVariable: 1,
        measureVariable: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LinkBar;
